module.exports = __webpack_public_path__ + "static/media/image_2021_03_11T11_53_14_686Z.29c6e81a.png";